/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { productsGet } from "../../funcs/productsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetProductRequest$inboundSchema,
};

export const tool$productsGet: ToolDefinition<typeof args> = {
  name: "products-get",
  description: `Retrieve a product by ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await productsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
